import { FiEdit3, FiUserPlus, FiX } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import PhoneInput from "../../../components/common/phoneInput/PhoneInput";
import Select from "../../../components/common/select/Select";
import styles from "./UserFormModal.module.css";

const UserFormModal = ({ isOpen, mode, values, onChange, onClose, onSubmit, saving, error }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  const isCreateMode = mode === "create";
  const title = isCreateMode ? t("pages.userForm.createTitle") : t("pages.userForm.editTitle");

  return (
    <div className={styles.overlay} onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="user-modal-title">
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <div className={styles.titleWrap}>
            <span className={styles.headerIcon}>{isCreateMode ? <FiUserPlus size={22} /> : <FiEdit3 size={22} />}</span>
            <h2 id="user-modal-title" className={styles.title}>{title}</h2>
          </div>
          <button type="button" className={styles.closeBtn} onClick={onClose} aria-label={t("pages.userForm.closeAria")}>
            <FiX size={20} />
          </button>
        </div>

        <form onSubmit={onSubmit} className={styles.form}>
          <div className={styles.formBody}>
            <div className={styles.formGroup}>
              <label className={styles.label}>{t("pages.userForm.name")}</label>
              <input
                type="text"
                name="name"
                value={values.name}
                onChange={onChange}
                className={styles.input}
                placeholder={t("pages.userForm.namePlaceholder")}
                autoComplete="off"
              />
            </div>

            <div className={styles.formGroup}>
              <label className={styles.label}>{t("pages.userForm.email")}</label>
              <input
                type="email"
                name="email"
                value={values.email}
                onChange={onChange}
                className={styles.input}
                placeholder={t("pages.userForm.emailPlaceholder")}
                autoComplete="email"
              />
            </div>

            <div className={styles.formGroup}>
              <label className={styles.label}>{t("pages.userForm.role")}</label>
              <Select
                name="role"
                value={values.role}
                onChange={onChange}
                className={styles.select}
                options={[
                  { value: "ADMIN", label: t("userRole.ADMIN") },
                  { value: "COORDINATOR", label: t("userRole.COORDINATOR") },
                  { value: "TEACHER", label: t("userRole.TEACHER") },
                ]}
              />
            </div>

            <div className={styles.formRow}>
              <div className={styles.formGroup}>
                <label className={styles.label}>{t("pages.userForm.nationalId")}</label>
                <input
                  type="text"
                  name="nationalId"
                  value={values.nationalId}
                  onChange={onChange}
                  className={styles.input}
                  placeholder={t("pages.userForm.nationalIdPlaceholder")}
                  autoComplete="off"
                />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label}>{t("pages.userForm.phone")}</label>
                <PhoneInput
                  name="phone"
                  value={values.phone || ""}
                  onChange={(local) => onChange({ target: { name: "phone", value: local } })}
                />
              </div>
            </div>

            <div className={styles.formGroup}>
              <label className={styles.label}>{t("pages.userForm.address")}</label>
              <input
                type="text"
                name="address"
                value={values.address}
                onChange={onChange}
                className={styles.input}
                placeholder={t("pages.userForm.addressPlaceholder")}
                autoComplete="street-address"
              />
            </div>

            {error && (
              <div className={styles.error} role="alert">
                {error}
              </div>
            )}
          </div>

          <div className={styles.actions}>
            <button type="button" onClick={onClose} className={styles.secondaryBtn}>
              {t("common.cancel")}
            </button>
            <button type="submit" disabled={saving} className={styles.primaryBtn}>
              {saving ? t("pages.userForm.saving") : isCreateMode ? t("pages.userForm.addBtn") : t("pages.userForm.saveBtn")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserFormModal;
